import React from "react";

import { Link } from "react-router-dom";
import { Form, Formik } from "formik";
import { TextInput } from "shared/components/text-input/text-input";
import { FormulaireSubmit } from "./formulaire-submit";
import {
  Resiliation,
  contratSchema,
} from "modules/resiliation/model/resiliation";
import Button from '@mui/material/Button';
import './formulaire.scss';
import ProgressBar from "shared/components/progress-bar/progress-bar";
import { isMobile } from "react-device-detect";
import { DropDown } from "shared/components/spb-dropdown/spb-dropdown";
import { Autocomplete } from "shared/components/spb-autocomplete/autocomplete";

export interface IFormulaireStep2Props {
  resiliation: Resiliation;
  compagnies: string[];
  submit: (resiliation: Resiliation) => void;
  cancel: () => void;
}

export const FormulaireStep2 = ({
  resiliation,
  compagnies,
  submit,
  cancel,
}: IFormulaireStep2Props) => {




  return (
    <div>
      <div className={isMobile ? 'content-mobile' : 'content'} >
        <div className="container-box">
          <Formik
            initialValues={resiliation.contrat}
            validationSchema={contratSchema}
            onSubmit={(values) => {
             
              submit({ ...resiliation, ...{ contrat: { ...values } } });
            }}
          >
            {({ values, errors, touched, handleChange }) => {
         


              return (


                <Form>

                  <div className="row top-buffer py-4" style={isMobile ? { flexDirection: "column" } : {}} >
                    <div className="col-6" style={isMobile ? { width: "100%" } : {}}>
                      {/* <TextInput
                        label="Où avez-vous souscrit votre contrat ? "
                        autoComplete="off"
                        type="text"
                        name="produit"
                        placeholder="ex : Auchan"
                        initialValue={values.produit}
                        touched={touched.produit}
                        handleChange={handleChange}
                        error={errors.produit}
                      /> */}


                    <Autocomplete
                          data={compagnies}
                          label="Où avez-vous souscrit votre contrat ? "
                          name="produit"
                          placeholder="ex : Auchan"
                          handleChange={handleChange}
                          initialValue={values.produit}
                        /> 
                    </div>
                    <div className="col-6" style={isMobile ? { width: "100%" } : {}}>
                      <TextInput
                        label="Nom de votre contrat  "
                        autoComplete="off"
                        type="text"
                        name="nomContrat"
                        placeholder="ex : 60jours/100nuits"
                        initialValue={values.nomContrat}
                        touched={touched.nomContrat}
                        handleChange={handleChange}
                        error={errors.nomContrat}
                      />
                    </div>
                  </div>

                  <div className="row top-buffer py-4" style={isMobile ? { flexDirection: "column" } : {}} >
                    <div className="col-6" style={isMobile ? { width: "100%" } : {}}>
                      <TextInput
                        label="Quelles garanties sont couvertes par votre contrat ?"
                        autoComplete="off"
                        type="text"
                        name="nomGarantie"
                        placeholder="ex : casse, vol"
                        initialValue={values.nomGarantie}
                        touched={touched.nomGarantie}
                        handleChange={handleChange}
                        error={errors.nomGarantie}
                      />
                    </div>
                    <div className="col-6" style={isMobile ? { width: "100%" } : {}}>
                      <TextInput
                        label="Numéro de votre adhésion/contrat* "
                        autoComplete="off"
                        type="text"
                        name="numAdhesion"
                        placeholder="ex : 128494U9430"
                        initialValue={values.numAdhesion}
                        touched={touched.numAdhesion}
                        handleChange={handleChange}
                        error={errors.numAdhesion}
                      />
                    </div>
                    <div className="textFooter pt-4">
                      <div className="textFooter1">* Champs obligatoires</div>
                    </div>
                  </div>
                  <FormulaireSubmit previous={() => cancel()} />
                </Form>)

            }

            }

          </Formik>
        </div>
      </div>
    </div>)
}


